class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#header-cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'header-cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class MinicartNostoCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.options = {};
    this.buyButtons = this.querySelectorAll('.minicart-nosto-buy-btn');

    this.buyButtons.forEach((buyButton) => {
      buyButton.addEventListener('click', function(e) {
        console.log('📌 Nosto Add-to-Cart button clicked');

        setTimeout(function() {
          window.theme.fetchAndOpenCart()
        }, 500);
      })
    })
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    this.options = {
      slidesPerView: 'auto',
      loop: false,
      speed: 500,
      spaceBetween: 10,
      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next'),
      },
    };

    this.slider = new Swiper(
      this.querySelector('[data-slider]'),
      this.options,
    );
  }
}

customElements.define('minicart-nosto-carousel', MinicartNostoCarousel);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'header-cart-icon-bubble',
//         section: 'header-cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);

// open minicart when url contains ?mini-cart-open
document.addEventListener('DOMContentLoaded', function(){
  if(location.href.indexOf('mini-cart-open') >= 0) {
    window.theme.fetchAndOpenCart()
  }
})

document.addEventListener("click", function (event) {
  if (event.target.matches(".cart__remove")) {
    if (!window.bundle_grouping) return;
    event.preventDefault();

    let lineItemKey = event.target.getAttribute("data-line-item-key");
    
    document.querySelector('.minicart-line-items').classList.add('bundle-updating');

    // Fetch cart data to get _bundle_id
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        let itemToRemove = cart.items.find(item => item.key === lineItemKey);
        
        if (itemToRemove) {
            let bundleId = itemToRemove.properties?._bundle_id;
            
            if (bundleId) {
                // all items with the same _bundle_id
                let bundleItems = cart.items.filter(item => item.properties?._bundle_id === bundleId);
                
                let updates = {};
                bundleItems.forEach(item => {
                  updates[item.key] = 0;
                });

                // remove all items with the same _bundle_id
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates })
                }).then(() => window.theme.fetchCart())
                  .finally(() => document.querySelector('.minicart-line-items').classList.remove('bundle-updating'));
            }
        }
    });
  }
});